import React from 'react';

const CAPTION = ['COURT_NAME', 'COUNTY_NAME', 'CASE_NUMBER', 'PLAINTIFF', 'DEFENDANT', 'DEPT', 'JUDGE', 'TITLE_OF_DOCUMENT'];
const HEARING = ['HEARING_DATE', 'HEARING_TIME', 'HEARING_LOCATION'];
const FIRM = ['ATTORNEY_BLOCK', 'FIRM_NAME', 'FIRM_ADDRESS', 'STATE_BAR_NO'];
const SECTIONS = ['INTRO', 'FACTS', 'ARGUMENT', 'PRAYER', 'SIGNATURE'];

export const TemplatePlaceholderPalette: React.FC<{ onInsert: (key: string) => void }>
  = ({ onInsert }) => {
  return (
    <div className="space-y-3">
      <PaletteGroup title="Caption" items={CAPTION} onInsert={onInsert} />
      <PaletteGroup title="Hearing" items={HEARING} onInsert={onInsert} />
      <PaletteGroup title="Firm" items={FIRM} onInsert={onInsert} />
      <PaletteGroup title="Sections" items={SECTIONS} onInsert={onInsert} />
    </div>
  );
};

const PaletteGroup: React.FC<{ title: string; items: string[]; onInsert: (key: string) => void }>
  = ({ title, items, onInsert }) => (
  <div>
    <div className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-1">{title}</div>
    <div className="flex flex-wrap gap-2">
      {items.map((k) => (
        <button key={k} className="px-2 py-1 border rounded text-xs border-gray-300 dark:border-gray-600 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700" onClick={() => onInsert(k)}>
          {`{{${k}}}`}
        </button>
      ))}
    </div>
  </div>
);

export default TemplatePlaceholderPalette;


